var root = '_24juip2';
var size = {sm:'_24juip3',md:'_24juip4',lg:'_24juip5'};
var spinner = '_24juip6';

export { root, size, spinner };
//# sourceMappingURL=loading-spinner.css.js.map
